import { useSuspenseQuery } from '@tanstack/react-query';
import {
  brokerageFirmControllerGetBrokerageFirmQueryOptions,
  legacyPermissionsControllerAtMeQueryOptions,
} from 'korint-sdk';
import { DistributionRequestListModule } from '../DistributionRequestListModule/DistributionRequestListModule';
import { DocumentsCommonListProductModule } from '../DocumentsCommonListProductModule/DocumentsCommonListProductModule';
import { Stack } from '@folio/components/ui/flex';

export function IntermediaryProductsModule() {
  const { data: user } = useSuspenseQuery({
    ...legacyPermissionsControllerAtMeQueryOptions(),
  });

  const {
    data: { firmType },
  } = useSuspenseQuery({
    ...brokerageFirmControllerGetBrokerageFirmQueryOptions(user.brokerageFirmId!),
  });

  return (
    <Stack>
      {firmType === 'RETAIL' && <DistributionRequestListModule isReadonly />}
      <DocumentsCommonListProductModule />
    </Stack>
  );
}
